import { render, staticRenderFns } from "./PgaOtherCustomerReferralEdit.vue?vue&type=template&id=2627fae0&"
import script from "./PgaOtherCustomerReferralEdit.vue?vue&type=script&lang=ts&"
export * from "./PgaOtherCustomerReferralEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2627fae0')) {
      api.createRecord('2627fae0', component.options)
    } else {
      api.reload('2627fae0', component.options)
    }
    module.hot.accept("./PgaOtherCustomerReferralEdit.vue?vue&type=template&id=2627fae0&", function () {
      api.rerender('2627fae0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/business-startups/customer-orders/components/edit/sub-components/PgaOtherCustomerReferralEdit.vue"
export default component.exports